"use client";

import { c as _c } from "react/compiler-runtime";
import { type RefObject, useEffect } from "react";
import { canAnimatePointer, loadGsapWithScrollTrigger, shouldReduceMotion } from "@/lib/gsap";
import { setupCaseCardHoverAnimation } from "./case-card-hover-animation";
export function useCasesCardAnimation(sectionRef) {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] !== sectionRef) {
    t0 = () => {
      if (shouldReduceMotion()) {
        return;
      }
      let cleanup;
      let cancelled = false;
      const setupAnimation = async function setupAnimation() {
        const {
          gsap
        } = await loadGsapWithScrollTrigger();
        if (cancelled) {
          return;
        }
        const hoverCleanups = [];
        const ctx = gsap.context(() => {
          const enableHover = canAnimatePointer() && window.matchMedia("(min-width: 1280px)").matches;
          const cards = gsap.utils.toArray(".case-card");
          const heading = sectionRef.current?.querySelector(".cases-section-heading");
          const headingTargets = heading ? [heading] : [];
          const controls = gsap.utils.toArray(".cases-section-control");
          const entranceTargets = [...headingTargets, ...controls, ...cards];
          gsap.set(entranceTargets, {
            opacity: 0,
            y: 36,
            filter: "blur(10px)"
          });
          gsap.timeline({
            scrollTrigger: {
              trigger: sectionRef.current,
              start: "top 90%",
              toggleActions: "play reverse restart reverse"
            }
          }).to(headingTargets, {
            opacity: 1,
            y: 0,
            filter: "blur(0px)",
            duration: 0.9,
            ease: "power3.out"
          }).to(controls, {
            opacity: 1,
            y: 0,
            filter: "blur(0px)",
            duration: 0.75,
            ease: "power3.out",
            stagger: 0.05
          }, 0.1).to(cards, {
            opacity: 1,
            y: 0,
            filter: "blur(0px)",
            duration: 1,
            ease: "power3.out",
            stagger: 0.09
          }, 0.18);
          cards.forEach(card => {
            if (!enableHover) {
              return;
            }
            hoverCleanups.push(setupCaseCardHoverAnimation(gsap, card));
          });
        }, sectionRef);
        cleanup = () => {
          for (const cleanupHover of hoverCleanups) {
            cleanupHover();
          }
          ctx.revert();
        };
      };
      setupAnimation();
      return () => {
        cancelled = true;
        cleanup?.();
      };
    };
    t1 = [sectionRef];
    $[0] = sectionRef;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
}